/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ListEventLogPayload,
  ListEventLogPayload$Outbound,
  ListEventLogPayload$outboundSchema,
} from "../components/listeventlogpayload.js";

export type ListEventLogSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListEventLogRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  listEventLogPayload: ListEventLogPayload;
};

/** @internal */
export type ListEventLogSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListEventLogSecurity$outboundSchema: z.ZodMiniType<
  ListEventLogSecurity$Outbound,
  ListEventLogSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listEventLogSecurityToJSON(
  listEventLogSecurity: ListEventLogSecurity,
): string {
  return JSON.stringify(
    ListEventLogSecurity$outboundSchema.parse(listEventLogSecurity),
  );
}

/** @internal */
export type ListEventLogRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ListEventLogPayload: ListEventLogPayload$Outbound;
};

/** @internal */
export const ListEventLogRequest$outboundSchema: z.ZodMiniType<
  ListEventLogRequest$Outbound,
  ListEventLogRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    listEventLogPayload: ListEventLogPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      listEventLogPayload: "ListEventLogPayload",
    });
  }),
);

export function listEventLogRequestToJSON(
  listEventLogRequest: ListEventLogRequest,
): string {
  return JSON.stringify(
    ListEventLogRequest$outboundSchema.parse(listEventLogRequest),
  );
}
